import React, {useEffect, useRef, useState} from "react";
import {
    Table,
    Tooltip,
    Popconfirm,
    DefaultTablePagination,
    notification,
    arraySorter,
} from "../../components/Elements/appUtils";
import {fetchProduct, updateProductStatusFxn, updateProductFxn, exportProductExcelFxn} from "./actions";
import AddProduct from "./addProduct";
import PageHeader from "../../components/Elements/pageHeader";
import _ from "lodash";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {deleteProductUrl} from "./api";
import {getMainMenuUrl} from "../mainmenu/api";
import {getMainCategoryUrl} from "../maincategory/api";
import {updateProductStatusUrl} from "./api";
import {getToken} from "../../request";
import {FetchCatgory} from "../variants/actions";
import Modal from "../../components/Elements/Modal";
import EditProduct from "./editProduct";
import {useDispatch} from "react-redux";

// let filterInit = {
//     name: "",
//     menu: "",
//     categoryId: "",
// };
let filterInit = {
    name: "",
    mainMenuId: "",
    mainCategoryId: "",
    categoryId: "",
};

function ProductList() {
    let dispatch = useDispatch();
    let tableRef = useRef();
    const navigate = useNavigate();
    let [filter, setFilter] = useState(filterInit);
    const appliedFilterRef = useRef(filterInit);
    const [categoryList, setCategoryList] = useState([]);
    const [status, setStatus] = useState("");
    const [editingRowId, setEditingRowId] = useState("");
    const [editFormData, setEditFormData] = useState({});
    const [mainMenus, setMainMenus] = useState([]);
    const [dynamicMainCategories, setDynamicMainCategories] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editProductId, setEditProductId] = useState("");
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                const currentFilter = appliedFilterRef.current || {};

                if (currentFilter.name) {
                    params.name = currentFilter.name;
                }
                if (currentFilter.mainMenuId) {
                    params.mainMenuId = currentFilter.mainMenuId;
                }
                if (currentFilter.mainCategoryId) {
                    params.mainCategoryId = currentFilter.mainCategoryId;
                }
                if (currentFilter.categoryId) {
                    params.categoryId = currentFilter.categoryId;
                }
                if (status) {
                    params.productStatus = {$in: status};
                } else {
                    params.productStatus = {$in: "Active"};
                }

                const hasSearchFilter = Boolean(
                    currentFilter.mainMenuId ||
                    currentFilter.mainCategoryId ||
                    currentFilter.categoryId ||
                    currentFilter.name
                );

                if (hasSearchFilter) {
                    const pageSize = Number(params.results || params.count || 20);
                    const currentPage = Number(params.page || 1);

                    let {data} = await fetchProduct({
                        ...params,
                        results: 2000,
                        page: 1,
                        regExFilters: ["name", "menu"],
                    });

                    if (data && Array.isArray(data.data)) {
                        const sorted = [...data.data].sort((a, b) => {
                            // 1. Main Category alphabetically (A-Z)
                            const mainCatA = (
                                (a.mainCategoryId && a.mainCategoryId.mainCategoryName) ||
                                a.mainCategory ||
                                (a.categoryId && a.categoryId.menu) ||
                                ""
                            ).trim();
                            const mainCatB = (
                                (b.mainCategoryId && b.mainCategoryId.mainCategoryName) ||
                                b.mainCategory ||
                                (b.categoryId && b.categoryId.menu) ||
                                ""
                            ).trim();
                            const mc = mainCatA.localeCompare(mainCatB, undefined, {
                                numeric: true,
                                sensitivity: "base",
                            });
                            if (mc !== 0) return mc;

                            // 2. Category alphabetically (A-Z)
                            const catA = (
                                (a.categoryId && a.categoryId.name) ||
                                a.category ||
                                ""
                            ).trim();
                            const catB = (
                                (b.categoryId && b.categoryId.name) ||
                                b.category ||
                                ""
                            ).trim();
                            const cc = catA.localeCompare(catB, undefined, {
                                numeric: true,
                                sensitivity: "base",
                            });
                            if (cc !== 0) return cc;

                            // No product sorting
                            return 0;
                        });

                        const start = (currentPage - 1) * pageSize;
                        const pagedList = sorted.slice(start, start + pageSize);

                        resolve({
                            ...data,
                            data: pagedList,
                            total: sorted.length,
                        });
                        return;
                    }

                    resolve(data);
                } else {
                    let {data} = await fetchProduct({
                        ...params,
                        regExFilters: ["name", "menu"],
                    });

                    resolve(data);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };


    useEffect(() => {
        filterEvent.loadCategory();
    }, [filter.mainCategoryId]);

    let filterEvent = {

        loadCategory: async () => {
            let obj = {
                results: 500,
                deleted: {$ne: true},
            };

            if (filter.mainCategoryId) {
                obj.mainCategoryId = filter.mainCategoryId;
            } else {
                setCategoryList([]);
                return;
            }

            let {data} = await FetchCatgory(obj);
            const sortedCategories = (data || []).sort((a, b) =>
                (a.name || "").trim().localeCompare((b.name || "").trim(), undefined, { numeric: true, sensitivity: "base" })
            );
            setCategoryList(sortedCategories);
        },
        _updateFilterState: (data) => {
            setFilter((prevState) => {
                return {
                    ...prevState,
                    ...data,
                };
            });
        },
    };

    const search = async () => {
        appliedFilterRef.current = {...filter};
        if (window.location.search) {
            window.history.replaceState({}, document.title, window.location.pathname);
        }
        tableRef.current.reload();
    };

    const handleExportExcel = () => {
        let exportParams = {};
        const currentFilter = appliedFilterRef.current || {};
        if (currentFilter.name) exportParams.name = currentFilter.name;
        if (currentFilter.mainMenuId) exportParams.mainMenuId = currentFilter.mainMenuId;
        if (currentFilter.mainCategoryId) exportParams.mainCategoryId = currentFilter.mainCategoryId;
        if (currentFilter.categoryId) exportParams.categoryId = currentFilter.categoryId;
        if (status) exportParams.productStatus = status;

        dispatch(exportProductExcelFxn(exportParams));
    };

    const deleteProduct = async (id) => {
        try {
            const response = await axios.delete(deleteProductUrl(id), getToken());

            if (response.data.error) {
                notification.error({
                    message: response.data.message,
                });
            } else {
                tableRef.current.reload();
                notification.success({
                    message: response.data.message,
                });
            }
        } catch (error) {
            console.error("Error getting the data:", error);
        }
    };

    const updateProductStatus = async (id) => {
        let resp = await dispatch(updateProductStatusFxn(id));
        if (resp && resp.success) {
            tableRef.current.reload();
        }
    };


    const getMainMenus = async () => {
        try {
            const res = await axios.get(getMainMenuUrl(), getToken());
            if (res.data.success) {
                const sorted = (res.data.data || []).sort((a, b) =>
                    (a.mainMenuName || "").trim().localeCompare((b.mainMenuName || "").trim(), undefined, { numeric: true, sensitivity: "base" })
                );
                setMainMenus(sorted);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const loadDynamicMainCategories = async () => {
        try {
            const res = await axios.get(getMainCategoryUrl(), getToken());
            if (res.data.success) {
                const filtered = (res.data.data || [])
                    .filter((item) => item.deleted !== true)
                    .sort((a, b) =>
                        (a.mainCategoryName || "").trim().localeCompare((b.mainCategoryName || "").trim(), undefined, { numeric: true, sensitivity: "base" })
                    );
                setDynamicMainCategories(filtered);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const loadAllCategories = async () => {
        let x = await FetchCatgory({
            results: 500,
            deleted: {$ne: true},
        });
        const sorted = (x.data || []).sort((a, b) =>
            (a.name || "").trim().localeCompare((b.name || "").trim(), undefined, { numeric: true, sensitivity: "base" })
        );
        setAllCategories(sorted);
    };
    const filteredMainCategories = dynamicMainCategories
        .filter((item) => {
            return (
                String(item.mainMenuId?._id || item.mainMenuId) ===
                String(editFormData.mainMenuId)
            );
        })
        .sort((a, b) =>
            (a.mainCategoryName || "").trim().localeCompare((b.mainCategoryName || "").trim(), undefined, { numeric: true, sensitivity: "base" })
        );

    const filteredCategories = allCategories
        .filter((item) => {
            return (
                String(item.mainCategoryId?._id || item.mainCategoryId) ===
                String(editFormData.mainCategoryId)
            );
        })
        .sort((a, b) =>
            (a.name || "").trim().localeCompare((b.name || "").trim(), undefined, { numeric: true, sensitivity: "base" })
        );
    const handleEditClick = (item) => {
        setEditingRowId(String(item?._id || ""));
        setEditFormData({
            name: item?.name || "",
            code: item?.code || "",
            price: item?.price || "",
            mainMenuId: item?.mainMenuId?._id || item?.mainMenuId || "",
            mainCategoryId: item?.mainCategoryId?._id || item?.mainCategoryId || "",
            categoryId: item?.categoryId?._id || item?.categoryId || "",
            vegNonVeg: item?.vegNonVeg || "",
        });
    };

    const handleEditChange = (field, value) => {
        setEditFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleCancelEdit = () => {
        setEditingRowId("");
        setEditFormData({});
    };

    const handleSaveEdit = async (item) => {
        try {
            const resolvedName = editFormData.name || "";
            const resolvedCode = editFormData.code || "";
            const resolvedPrice = editFormData.price || "";
            const resolvedMainMenuId =
                editFormData.mainMenuId ||
                item?.mainMenuId?._id ||
                item?.mainMenuId ||
                "";
            const resolvedMainCategoryId =
                editFormData.mainCategoryId ||
                item?.mainCategoryId?._id ||
                item?.mainCategoryId ||
                "";
            const resolvedCategoryId =
                editFormData.categoryId ||
                item?.categoryId?._id ||
                item?.categoryId ||
                "";

            if (!resolvedName.trim()) {
                notification.warning({message: "Please enter Name"});
                return;
            }

            if (!resolvedCode.trim()) {
                notification.warning({message: "Please enter Code"});
                return;
            }

            // if (resolvedPrice === "" || resolvedPrice === null || resolvedPrice === undefined)
            if (resolvedPrice === "" || resolvedPrice === null || resolvedPrice === undefined) {
                notification.warning({message: "Please enter Price"});
                return;
            }

            if (!resolvedMainMenuId) {
                notification.warning({message: "Please select Main Menu"});
                return;
            }

            if (!resolvedMainCategoryId) {
                notification.warning({message: "Please select Main Category"});
                return;
            }

            if (!resolvedCategoryId) {
                notification.warning({message: "Please select Category"});
                return;
            }
            if (!(editFormData.vegNonVeg || item?.vegNonVeg)) {
                notification.warning({message: "Please select Veg/Non-Veg/Egg"});
                return;
            }

            const selectedMainMenu = mainMenus.find(
                (x) => String(x._id) === String(resolvedMainMenuId)
            );

            const selectedMainCategory = dynamicMainCategories.find(
                (x) => String(x._id) === String(resolvedMainCategoryId)
            );

            let fd = new FormData();

            fd.append(
                "obj",
                JSON.stringify({
                    _id: item._id,
                    name: resolvedName,
                    code: resolvedCode,
                    price: resolvedPrice,
                    mainMenuId: resolvedMainMenuId,
                    mainCategoryId: resolvedMainCategoryId,
                    categoryId: resolvedCategoryId,
                    vegNonVeg: editFormData.vegNonVeg || item?.vegNonVeg || "",
                    menu:
                        selectedMainMenu?.mainMenuName ||
                        item?.mainMenuId?.mainMenuName ||
                        item?.menu ||
                        "",
                    mainCategory:
                        selectedMainCategory?.mainCategoryName ||
                        item?.mainCategoryId?.mainCategoryName ||
                        item?.mainCategory ||
                        "",
                })
            );

            let resp = await dispatch(updateProductFxn(fd));

            if (resp && resp.success) {
                setEditingRowId("");
                setEditFormData({});
                tableRef.current.reload();
            }
        } catch (error) {
            console.error("Error updating product:", error);
            notification.error({
                message: "Failed to update product",
            });
        }
    };

    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
        },
        // {
        //     title: "Name",
        //     dataIndex: "name",
        //     key: "name",
        // },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            render: (text, item) => {
                return String(editingRowId) === String(item?._id) ? (
                    <input
                        type="text"
                        className="form-control"
                        value={editFormData.name || ""}
                        onChange={(e) => handleEditChange("name", e.target.value)}
                        autoFocus
                    />
                ) : (
                    text
                );
            },
        },
        {
            title: "Main Menu",
            dataIndex: "mainMenuId",
            key: "mainMenuId",
            render: (item, record) => {
                if (String(editingRowId) === String(record?._id)) {
                    return (
                        <select
                            className="form-control"
                            value={editFormData.mainMenuId || ""}
                            onChange={(e) => {
                                handleEditChange("mainMenuId", e.target.value);
                                handleEditChange("mainCategoryId", "");
                                handleEditChange("categoryId", "");
                            }}
                        >
                            <option value="">Select Main Menu</option>
                            {mainMenus.map((menu) => (
                                <option key={menu._id} value={menu._id}>
                                    {(menu.mainMenuName || "").trim()}
                                </option>
                            ))}
                        </select>
                    );
                }

                return <span>{item?.mainMenuName || ""}</span>;
            },
        },
//         {
//             title: "Main Menu",
//             dataIndex: "mainMenuId",
//             key: "mainMenuId",
//             render: (item,) => {
//                 return <span>{item?.mainMenuName || ""}</span>;
//             },
//         },
        // {
        //   title: "Main Category",
        //   dataIndex: "categoryId",
        //   key: "categoryId",
        //   render: (text, record, index) => {
        //     return (
        //       <span>
        //         {record.categoryId && record.categoryId.menu
        //           ? record.categoryId.menu
        //           : ""}
        //       </span>
        //     );
        //   },
        // },
        // {
        //     title: "Main Category",
        //     dataIndex: "mainCategoryId",
        //     key: "mainCategoryId",
        //     render: (item) => {
        //         return <span>{item?.mainCategoryName || ""}</span>;
        //     },
        // },
        {
            title: "Main Category",
            dataIndex: "mainCategoryId",
            key: "mainCategoryId",
            render: (item, record) => {
                if (String(editingRowId) === String(record?._id)) {
                    return (
                        <select
                            className="form-control"
                            value={editFormData.mainCategoryId || ""}
                            onChange={(e) => {
                                handleEditChange("mainCategoryId", e.target.value);
                                handleEditChange("categoryId", "");
                            }}
                        >
                            <option value="">Select Main Category</option>
                            {filteredMainCategories.map((cat) => (
                                <option key={cat._id} value={cat._id}>
                                    {(cat.mainCategoryName || "").trim()}
                                </option>
                            ))}
                        </select>
                    );
                }

                return <span>{item?.mainCategoryName || ""}</span>;
            },
        },

        {
            title: "Category",
            dataIndex: "categoryId",
            key: "categoryId",
            render: (item, record) => {
                if (String(editingRowId) === String(record?._id)) {
                    return (
                        <select
                            className="form-control"
                            value={editFormData.categoryId || ""}
                            onChange={(e) => handleEditChange("categoryId", e.target.value)}
                        >
                            <option value="">Select Category</option>
                            {filteredCategories.map((cat) => (
                                <option key={cat._id} value={cat._id}>
                                    {(cat.name || "").trim()}
                                </option>
                            ))}
                        </select>
                    );
                }

                return (
                    <span>
                {record.categoryId && record.categoryId.name
                    ? record.categoryId.name
                    : ""}
            </span>
                );
            },
        },
        {
            title: "GST",
            dataIndex: "gst",
            key: "gst",
            // render: (text, record) => {
            //     if (!record.categoryId) return "--";
            //     return record.categoryId.gst ? "Yes" : "No";
            // },
            render: (text, record) => {
                if (typeof record.gst === "boolean") {
                    return record.gst ? "Yes" : "No";
                }

                if (record.categoryId) {
                    return record.categoryId.gst ? "Yes" : "No";
                }

                return "--";
            }
        },
        {
            title: "Discount",
            dataIndex: "discount",
            key: "discount",
            render: (text, record) => {
                if (!record.categoryId) return "--";
                return record.categoryId.discount ? "Yes" : "No";
            },
        },

        // {
        //     title: "Code",
        //     dataIndex: "code",
        //     key: "code",
        //     render: (item) => {
        //         return item ? (
        //             <label className={"label label-info label-style"}>{item}</label>
        //         ) : (
        //             ""
        //         );
        //     },
        // },
        {
            title: "Code",
            dataIndex: "code",
            key: "code",
            render: (item, record) => {
                if (String(editingRowId) === String(record?._id)) {
                    return (
                        <input
                            type="text"
                            className="form-control"
                            value={editFormData.code || ""}
                            onChange={(e) => handleEditChange("code", e.target.value)}
                        />
                    );
                }

                return item ? (
                    <label className={"label label-info label-style"}>{item}</label>
                ) : (
                    ""
                );
            },
        },

        {
            title: "Price",
            dataIndex: "price",
            key: "price",
            render: (item, record) => {
                if (String(editingRowId) === String(record?._id)) {
                    return (
                        <input
                            type="number"
                            className="form-control"
                            value={editFormData.price || ""}
                            onChange={(e) => handleEditChange("price", e.target.value)}
                        />
                    );
                }

                return item ? <>Rs. {item}</> : "";
            },
        },

        //
        // {
        //     title: "Veg/Non-Veg/Egg",
        //     dataIndex: "vegNonVeg",
        //     key: "vegNonVeg",
        //     render: (item, record) => {
        //         if (String(editingRowId) === String(record?._id)) {
        //             return (
        //                 <select
        //                     className="form-control"
        //                     value={editFormData.vegNonVeg || ""}
        //                     onChange={(e) => handleEditChange("vegNonVeg", e.target.value)}
        //                 >
        //                     <option value="">Select</option>
        //                     <option value="Veg">Veg</option>
        //                     <option value="Non-Veg">Non-Veg</option>
        //                     <option value="Egg">Egg</option>
        //                 </select>
        //             );
        //         }
        //
        //         return item ? (
        //             <>
        //                 {item == "Veg" ? (
        //                     <label className={"label label-warning label-style"}>
        //                         {item}
        //                     </label>
        //                 ) : (
        //                     <label className={"label label-danger label-style"}>{item}</label>
        //                 )}
        //             </>
        //         ) : null;
        //     },
        // },
        {
            title: "Veg/Non-Veg/Egg",
            dataIndex: "vegNonVeg",
            key: "vegNonVeg",
            render: (item, record) => {
                if (String(editingRowId) === String(record?._id)) {
                    return (
                        <select
                            className="form-control"
                            value={editFormData.vegNonVeg || ""}
                            onChange={(e) => handleEditChange("vegNonVeg", e.target.value)}
                        >
                            <option value="">Select</option>
                            <option value="Veg">Veg</option>
                            <option value="Non-Veg">Non-Veg</option>
                            <option value="Egg">Egg</option>
                        </select>
                    );
                }

                return item ? (
                    <>
                        {item === "Veg" ? (
                            <label className={"label label-success label-style"}>
                                {item}
                            </label>
                        ) : item === "Egg" ? (
                            <label
                                className={"label label-style"}
                                style={{backgroundColor: "#f0ad4e", color: "#fff"}}
                            >
                                {item}
                            </label>
                        ) : (
                            <label className={"label label-danger label-style"}>
                                {item}
                            </label>
                        )}
                    </>
                ) : null;
            },
        },
        {
            title: "Special Tags",
            dataIndex: "tag",
            key: "tag",
            render: (tag) => {
                if (!tag) {
                    return <span>-</span>;
                }
                const getTagStyle = (tagName) => {
                    switch (tagName) {
                        case "Chef's Special":
                            return { backgroundColor: "#fff3cd", color: "#856404", border: "1px solid #ffeeba" };
                        case "Most Lovable":
                            return { backgroundColor: "#f8d7da", color: "#721c24", border: "1px solid #f5c6cb" };
                        case "Hot Selling":
                            return { backgroundColor: "#d4edda", color: "#155724", border: "1px solid #c3e6cb" };
                        default:
                            return { backgroundColor: "#e2e3e5", color: "#383d41" };
                    }
                };

                const style = getTagStyle(tag);
                return (
                    <span style={{
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "600",
                        ...style
                    }}>
        {tag}
      </span>
                );
            }
        },
        {
            title: "Status",
            dataIndex: "productStatus",
            key: "productStatus",
            render: (productStatus) => {
                let backgroundColor = "";
                if (productStatus === "Active") {
                    backgroundColor = "lightgreen";
                } else if (productStatus === "Inactive") {
                    backgroundColor = "lightcoral";
                }
                return (
                    <div>
                        {productStatus == "Active" ? (
                            <label className={"label label-success label-style"}>
                                {productStatus}
                            </label>
                        ) : (
                            <label className={"label label-danger label-style"}>
                                {productStatus}
                            </label>
                        )}
                    </div>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (v, item) => {
                if (String(editingRowId) === String(item?._id)) {
                    return (
                        <div className={'action-btn-group'}>
                            <a className={"btn btn-outline-success btn-sm"}
                               onClick={(e) => {
                                   e.preventDefault();
                                   handleSaveEdit(item);
                               }}>
                                Save
                            </a>
                            <a
                                className={"btn btn-danger btn-sm ml-2"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleCancelEdit();
                                }}>
                                Cancel
                            </a>
                        </div>
                    );
                }
                return (
                    <div className={'action-btn-group'}>
                        <Tooltip title={"Quick Edit"} className="ml-4">
                            <a
                                className={"btn btn-warning btn-sm"}
                                onClick={() => {
                                    handleEditClick(item);
                                }}
                            >
                                <i className="fa fa-pen"></i>
                            </a>
                        </Tooltip>

                        <Tooltip title={"Full Edit"}>
                            <a
                                className={"btn btn-warning btn-sm"}
                                onClick={() => {
                                    navigate(`/editProduct?_id=${item._id}`);
                                }}
                            >
                                <i className={"fa fa-edit far"}/>
                            </a>
                        </Tooltip>

                        <Tooltip title={"Delete"}>
                            <Popconfirm
                                title={"Are your sure, you want to delete Product?"}
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    deleteProduct(item._id);
                                }}
                            >
                                <a className={"btn btn-warning btn-sm"}>
                                    <i className={"fa fa-trash far"}/>
                                </a>
                            </Popconfirm>
                        </Tooltip>

                        <Tooltip title={"Status"}>
                            <Popconfirm
                                title={"Are your sure, you want to Update Product Status?"}
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    updateProductStatus(item._id);
                                }}
                            >
                                <a className={"btn btn-info btn-sm"}>Status</a>
                            </Popconfirm>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];

    const getColumns = () => {
        let columnArr = [];
        _.each(columns, (item) => {
            if (!item.hide) {
                columnArr.push(item);
            }
        });
        return columnArr;
    };

    // useEffect(() => {
    //     setFieldByParams();
    // }, []);
    useEffect(() => {
        if (window.location.search) {
            window.history.replaceState({}, document.title, window.location.pathname);
        }
        getMainMenus();
        loadDynamicMainCategories();
        loadAllCategories();
    }, []);
    const filterMainCategories = dynamicMainCategories
        .filter((item) => {
            if (!filter.mainMenuId) return false;

            return (
                String(item.mainMenuId?._id || item.mainMenuId) ===
                String(filter.mainMenuId)
            );
        })
        .sort((a, b) =>
            (a.mainCategoryName || "").trim().localeCompare((b.mainCategoryName || "").trim(), undefined, { numeric: true, sensitivity: "base" })
        );
    return (

        <PageHeader
            title={"Products"}
            extraLink={[
                {
                    name: "Add Product",
                    link: "/addproduct",
                },
            ]}
            extraContent={
                <button
                    className="btn btn-outline-success btn-sm"
                    onClick={handleExportExcel}
                    type="button"
                >
                    <i className="fa fa-file-excel mr-1"></i> Export Excel
                </button>
            }>
            {/*<AddProduct isEmbedded />*/}
            <div className="card mb-3">
                <div className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">Add Product</h6>
                    </div>
                    <AddProduct
                        isEmbedded
                        onClose={() => {
                            tableRef.current.reload();
                        }}
                    />
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-2">
                    <input
                        type="text"
                        className="form-control search-filters"
                        name="name"
                        placeholder="Search by Name"
                        value={filter.name}
                        onChange={(e) => {
                            filterEvent._updateFilterState({name: e.target.value});
                        }}
                    />
                </div>

                <div className="col-md-2">
                    <select
                        className="form-control search-filters"
                        onChange={(e) => {
                            filterEvent._updateFilterState({
                                mainMenuId: e.target.value,
                                mainCategoryId: "",
                                categoryId: "",
                            });
                        }}
                        value={filter.mainMenuId}
                    >
                        <option value="">Choose Main Menu</option>
                        {mainMenus.map((item) => (
                            <option key={item._id} value={item._id}>
                                {(item.mainMenuName || "").trim()}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-2">
                    <select
                        className="form-control search-filters"
                        onChange={(e) => {
                            filterEvent._updateFilterState({
                                mainCategoryId: e.target.value,
                                categoryId: "",
                            });
                        }}
                        value={filter.mainCategoryId}
                    >
                        <option value="">Choose Main Category</option>
                        {filterMainCategories.map((item) => (
                            <option key={item._id} value={item._id}>
                                {(item.mainCategoryName || "").trim()}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-2">
                    <select
                        className="form-control search-filters"
                        onChange={(e) => {
                            filterEvent._updateFilterState({categoryId: e.target.value});
                        }}
                        value={filter.categoryId}
                    >
                        <option value="">Choose Category</option>
                        {categoryList && categoryList.length
                            ? categoryList.map((item) => (
                                <option key={item._id} value={item._id}>
                                    {(item.name || "").trim()}
                                </option>
                            ))
                            : null}
                    </select>
                </div>

                <div className="col-md-2">
                    <select
                        className="form-control search-filters"
                        onChange={(e) => {
                            setStatus(e.target.value);
                            tableRef.current.reload();
                        }}
                        value={status}
                    >
                        <option value={"Active"}>Active</option>
                        <option value={"Inactive"}>Inactive</option>
                    </select>
                </div>

                {/*<div className="col-md-2 mt-2">*/}
                {/*    <div className="search-wrap">*/}
                {/*        <button className="btn btn-info" onClick={search}>*/}
                {/*            Search*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="col-md-2 d-flex align-items-end">
                    <div className="search-wrap w-100">
                        <button className="btn btn-info w-100" onClick={search}>
                            Search
                        </button>
                    </div>
                </div>
            </div>

            <div className="card mb-0">
                <div className="table-responsive">

                    <Table
                        apiRequest={apiRequest}
                        columns={getColumns()}
                        pagination={DefaultTablePagination()}
                        ref={tableRef}
                        extraProps={{
                            onRow: (record) => ({
                                // onDoubleClick: () => handleEditClick(record),
                            }),
                        }}
                    />
                </div>
            </div>
        </PageHeader>
    );
}

export default ProductList;
